import { z } from 'zod';

export const GIFT_PASS_TAG_COLORS = ['gold', 'forest', 'leaf', 'cream'] as const;
export type GiftPassTagColor = (typeof GIFT_PASS_TAG_COLORS)[number];

export const GIFT_PASS_BUNDLE_MAX_TAGS = 3;
/** Counted including any `[icon]` codes in the text. */
export const GIFT_PASS_TAG_TEXT_MAX_LENGTH = 24;

export interface GiftPassBundleTag {
  /** May include `[icon]` codes the booking site renders as icons. */
  text: string;
  color: GiftPassTagColor;
}

export const giftPassBundleTagSchema = z
  .object({
    text: z.string().trim().min(1).max(GIFT_PASS_TAG_TEXT_MAX_LENGTH),
    color: z.enum(GIFT_PASS_TAG_COLORS),
  })
  .strict();

export const giftPassBundleTagsSchema = z
  .array(giftPassBundleTagSchema)
  .max(GIFT_PASS_BUNDLE_MAX_TAGS);
